// extracted by mini-css-extract-plugin
module.exports = {"filterBody":"NSearchStudents_filterBody__NA0XA","filterImgContent":"NSearchStudents_filterImgContent__2uOZH"};